import { Page, View, Text, Link, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { getImageSrc } from '@utils/fn';
import { APP_HOST } from '@utils/apiHooks';

export interface CoLocatedEventsPageProps {
  event: PublicEventDetailsResponse;
  coLocatedEvents: PublicEventDetailsResponse[] | undefined;
  footer: JSX.Element;
}

const CoLocatedEventsPage = ({
  event,
  coLocatedEvents,
  footer,
}: CoLocatedEventsPageProps) => {
  const { t } = useTranslation();

  const coEvents = useMemo(() => {
    return coLocatedEvents?.filter(e => e?.id !== event?.id);
  }, [coLocatedEvents, event?.id]);

  const getItem = ({
    logo,
    text,
    link,
  }: {
    logo: string;
    text: string;
    link: string;
  }) => {
    return (
      <View style={styles.itemWrapper}>
        <Image src={logo} style={styles.logoImage} />

        <Text style={styles.itemTitle}>{text}</Text>

        <View
          style={{
            ...styles.fullWidthButton,
            backgroundColor: event?.design?.themeColor ?? 'black',
          }}
        >
          <Link src={link} style={styles.buttonText}>
            {t('view-event')}
          </Link>
        </View>
      </View>
    );
  };

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.leftColumn,
        }}
      >
        <View>
          <Text style={{ ...styles.title }}>{'CO-LOCATED EVENTS'}</Text>

          <View
            style={{
              ...globalStyles.lineBar,
              borderColor: event?.design?.themeColor ?? 'black',
              marginLeft: 0,
            }}
          />

          <Text style={styles.description}>{t('co-located-event-text')}</Text>
        </View>

        {getItem({
          logo: getImageSrc(coEvents?.[0]?.images?.logo ?? ''),
          text: coEvents?.[0]?.description ?? '',
          link: `${APP_HOST}/events/${coEvents?.[0]?.slug ?? ''}`,
        })}
      </View>

      <View style={styles.rightColumn}>
        {coEvents?.slice(1)?.map(e => {
          return getItem({
            logo: getImageSrc(e?.images?.logo ?? ''),
            text: e?.description ?? '',
            link: `${APP_HOST}/events/${e?.slug}`,
          });
        })}
      </View>

      {footer}
    </Page>
  );
};

export default CoLocatedEventsPage;
